module.exports = __webpack_public_path__ + "static/media/endless-logo.685b6669.png";